import { DiContainerInjectFn } from '@/di/ts';
import { ApiService } from '@/api/services/api.service';

export default ((container) => {
  container.bind(ApiService).to(ApiService).inSingletonScope();
}) as DiContainerInjectFn;
